export * from './label-select.component';
